module.exports = __webpack_public_path__ + "img/cocktail-pro-header-swish.png";